import { Component, OnInit } from "@angular/core";
import { boundingExtent } from "ol/extent";
import { fromExtent } from "ol/geom/Polygon";
import { transform, transformExtent, get as getProjection } from "ol/proj";
import { Feature, View } from "ol";

import { HsLanguageService, HsMapService } from "hslayers-ng";

import { AppService } from "src/app.service";
import { StrategyCommonService } from "../../strategy/strategy-common.service";

@Component({
  selector: "location-switcher",
  templateUrl: "./location-switcher.component.html",
  styleUrls: ["./location-switcher.component.scss"],
})
export class LocationSwitcherComponent implements OnInit {
  bboxLayer;
  constructor(
    public StrategyCommonService: StrategyCommonService,
    public HsLanguageService: HsLanguageService,
    public HsMapService: HsMapService,
    public AppService: AppService
  ) {
    this.bboxLayer = this.HsMapService.findLayerByTitle("cfd");
  }

  ngOnInit(): void {}

  locationSelected(location) {
    const source = this.bboxLayer.getSource();
    this.StrategyCommonService.selectedLocation = location.location;
    this.StrategyCommonService.setSeasonStart();
    source.clear();

    const extent = transformExtent(
      boundingExtent(location.bbox),
      "EPSG:4326",
      location.crs
    );

    const polygon = fromExtent(extent);
    const feature = new Feature(polygon);
    source.addFeature(feature);

    this.AppService.updateLayerParams.next({ location: location.code });
    this.HsMapService.loaded().then((map) => {
      const enlargedExtent = boundingExtent(location.bbox);
      enlargedExtent[0] -= 0.5;
      enlargedExtent[1] -= 1;
      enlargedExtent[2] += 0.5;
      enlargedExtent[3] += 1;
      const enlargedTransform = transformExtent(
        enlargedExtent,
        "EPSG:4326",
        location.crs
      );

      map.setView(
        new View({
          projection: getProjection(location.crs),
          // center: transform([15.628, 49.864249], "EPSG:4326", "EPSG:5514"), //Latitude longitude    to S-JTSK
          extent: enlargedTransform,
          multiWorld: false,
          zoom: 8,
          showFullExtent: true,
        })
      );
      map.getView().fit(enlargedTransform, {
        size: map.getSize(),
      });
    });
  }
}
